<!--
  CopyIconButton Component
  Icon-only ghost copy button with tooltip; shows a success check while `copied` is true (Spec 105 E8).
  Extra attributes (data-testid, ...) and the click event are forwarded to the button.
-->
<script lang="ts">
  import { Copy, CheckCircle } from 'lucide-svelte';
  import Button from './Button.svelte';
  import Tooltip from './Tooltip.svelte';

  export let copied = false;
  export let label: string;
  export let copiedLabel: string;

  $: text = copied ? copiedLabel : label;
</script>

<Tooltip {text}>
  <Button variant="ghost" size="sm" iconOnly aria-label={text} {...$$restProps} on:click>
    {#if copied}
      <CheckCircle class="w-4 h-4 text-success" strokeWidth={1.5} />
    {:else}
      <Copy class="w-4 h-4" strokeWidth={1.5} />
    {/if}
  </Button>
  <span class="sr-only" aria-live="polite">{copied ? copiedLabel : ''}</span>
</Tooltip>
